import Store  from '../../../../redux';
import axios from "axios"; 
const version = "v1";   
const API_BASE = process.env.REACT_APP_API_URL_LOGIN;

const getHeaders = () => {
    const user = Store?.getState()?.user;
    return {
        'X-FNOTRADER-SECRET': user?.loginSecret,
        'X-FNOTRADER-USERID': user?.userID
    };
}

//Save chart
export async function saveChartApiRequest(data) {
    var bodyFormData = new FormData();
    bodyFormData.append('content', data.content);
    bodyFormData.append('name', data.name);
    bodyFormData.append('resolution', data.resolution);
    bodyFormData.append('id', data.id);
    bodyFormData.append('symbol', data.symbol);
    const url = `charts?client=QT&user=${getHeaders()['X-FNOTRADER-USERID']}`
    return sendRequest('post', url, bodyFormData, getHeaders());
}

//getAllCharts
export async function getAllChartsApiRequest() {
    const url = `charts?client=QT&user=${getHeaders()['X-FNOTRADER-USERID']}`
    return sendRequest('get', url, {}, getHeaders());
}

//getChartContent
export async function getChartContentApiRequest(id) {
  const url = `charts?chart_id=${id}&client=QT&user=${getHeaders()['X-FNOTRADER-USERID']}`
  return sendRequest('get', url, {}, getHeaders());
}

//removeChart
export async function removeChartApiRequest(id) {
  const url = `charts?chart_id=${id}&client=QT&user=${getHeaders()['X-FNOTRADER-USERID']}`
  return sendRequest('delete', url, {}, getHeaders());
}

 //saveStudyTemplate
export async function saveStudyTemplateApiRequest(data) {
  var bodyFormData = new FormData();
  bodyFormData.append('content', data.content);
  bodyFormData.append('name', data.name);
  bodyFormData.append('meta_info', data.meta_info);
  const url = `study_templates?client=QT&user=${getHeaders()['X-FNOTRADER-USERID']}`
  return sendRequest('post', url, bodyFormData, getHeaders());
}

//getAllStudyTemplates
export async function getAllStudyTemplatesApiRequest() {
  const url = `study_templates?client=QT&user=${getHeaders()['X-FNOTRADER-USERID']}`
  return sendRequest('get', url, {}, getHeaders());
}

//getStudyTemplateContent
export async function getStudyTemplateContentApiRequest(template) {
  const url = `study_templates?template=${template}&client=QT&user=${getHeaders()['X-FNOTRADER-USERID']}`
  return sendRequest('get', url, {}, getHeaders());
}

//removeStudyTemplate
export async function removeStudyTemplateApiRequest(template) {
  const url = `study_templates?template=${template}&client=QT&user=${getHeaders()['X-FNOTRADER-USERID']}`
  return sendRequest('delete', url, {}, getHeaders());
}

const sendRequest = async (type, url, params, headers) => {
    try {
      const clientAuth = axios.create({
        baseURL: `${API_BASE}/${version}/`,
        headers: headers
      });
      const clientData = axios.create({
        baseURL: `${API_BASE}/${version}/`,
        headers: headers
      });
  
      if (type === "post") {
        let response = await clientAuth.post(`/${url}`, params);
        return response?.data;
      } else if (type === "get") {
        let response = await clientData.get(`/${url}`, params);
        return response?.data;
      } else if(type === "delete") {
        let response = await clientData.delete(`/${url}`, params);
        return response?.data;
      }
    } catch (e) {
      let error = e?.response?.data || "";
      console.log("error : ", e);
      return error;
    }
  };